import {WorkItem} from '../../models';

export interface WorkItemsResponse {
  type: string;
  items: WorkItem[];
}
